import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";

export default function GroupDialog({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    descricao: string;
    ajuda?: string;
    rodape?: string;
    imagemBase64?: string | null;
  }) => void;
}) {
  const [descricao, setDescricao] = useState("");
  const [ajuda, setAjuda] = useState("");
  const [rodape, setRodape] = useState("");
  const [img, setImg] = useState<string | null>(null);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setImg(reader.result as string);
    reader.readAsDataURL(file);
  };

  const handleOk = () => {
    onSubmit({ descricao, ajuda, rodape, imagemBase64: img });
    setDescricao("");
    setAjuda("");
    setRodape("");
    setImg(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Novo Grupo</DialogTitle>
      <DialogContent>
        <Box mt={1} display="grid" gap={2}>
          <TextField
            label="Descrição"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            fullWidth
          />
          <TextField
            label="Ajuda"
            value={ajuda}
            onChange={(e) => setAjuda(e.target.value)}
            fullWidth
          />
          <TextField
            label="Rodapé"
            value={rodape}
            onChange={(e) => setRodape(e.target.value)}
            fullWidth
          />
          <Button component="label" variant="outlined">
            Selecionar imagem
            <input type="file" hidden accept="image/*" onChange={handleFile} />
          </Button>
          {img && <img src={img} alt="preview" style={{ maxWidth: 160 }} />}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleOk}
          disabled={!descricao.trim()}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
